<template>
  <div class="wrapper" ref="wrapper">
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BScroll from 'better-scroll';

export default {
  name: 'Scroll',
  data(){
    return {
      scroll: null,
    }
  },
  props: {
    probeType: {
      type: Number,
      default: 0
    },
    pullUpLoad: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState(['currentPop']),
  },
  watch: {
    currentPop(newValue){
      if(newValue === 'Rule'){
        this.scrollInit();
      }
    },
  },
  mounted(){
    this.scrollInit();
  },
  methods: {
    scrollInit(){
      setTimeout(() => {
        // 1.创建BScroll对象
        this.scroll = new BScroll(this.$refs.wrapper, {
          click: true,
          mouseWheel: true,
          probeType: this.probeType,
          pullUpLoad: this.pullUpLoad,
          scrollbar: {
            fade: false,  // 是否启用渐隐效果
            interactive: true,  // 是否允许拖拽滚动条
            style: {
              // 在此处配置滚动条的样式
              backgroundColor: '#FF0000',  // 滚动条颜色
              borderRadius: '3px',         // 滚动条圆角
              width: '6px',                // 滚动条宽度
            },
            wrapperStyle: {
              // 配置滚动条轨道的样式
              backgroundColor: '#FF0000', // 轨道颜色
            },
          },
        })
        this.scroll.scrollTo(0, -1);
      }, 0)
    },
  },
}
</script>

<style scoped>
.wrapper{ overflow: hidden; position: relative;}
:deep(.bscroll-vertical-scrollbar){ width: 12px!important; background: #8a41ea; border-radius: 6px; z-index: 1!important;}
:deep(.bscroll-indicator){ background: #f9ff55!important; border-radius: 6px!important;}
</style>